import { render, staticRenderFns } from "./OrderEditProduct.vue?vue&type=template&id=1b67f19c&"
import script from "./OrderEditProduct.vue?vue&type=script&lang=js&"
export * from "./OrderEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports